import { MyNotification, addNotification } from "src/Components/Shared/NotificationSystem/NotificationSystem";

export function showSuccessAlert(Message: string) {
    const ObjMyNotification: MyNotification = { message: Message, level: "success", position: "br" };
    addNotification(ObjMyNotification);
}

export function showErrorAlert(Message: string) {
    const ObjMyNotification: MyNotification = { message: Message, level: "error", position: "br" };
    addNotification(ObjMyNotification);
}


// WEBPACK FOOTER //
// ./src/loaders/NotificationLoader.ts